import React, { Component } from "react";
import { CLIENT_TOKEN, API_URL } from "../../common/constants";
import "./SingleBasketProduct.scss";
import Api from "../../common/helpers/Api";
import { toast } from "react-toastify";

export default class SingleBasketProduct extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  async deleteProduct(id) {
    console.log(id);
    if (!id) {
      return;
    }
    this.props.willRefreshCart();
    const articleId = id.split(`/${CLIENT_TOKEN}articles/`)[1];

    try {
      await Api.delete("articles/" + articleId);

      this.props.refreshCart();
    } catch (reason) {
      this.props.stopRefreshCart();
      toast.error("Une erreur s'est produite");
      this.props.store.getLoginStatus();
    }
  }

  render() {
    const { product, checkout } = this.props;

    let defaultDate = new Date()

    // product.canUpdateQuantity = true;
    return (
      <div className="product">
        <div className="product--details--left">
          <p className="product--name">{product.productName}</p>
          {/* {product.description && (
            <p className="product--description">{product.productDescription}</p>
          )} */}
        </div>
        <div className="product--details--right">
          <div className="product--price">
            <span>{product.priceTI / 100}€</span>
          </div>
          {!checkout && (
            <div className="product--delete">
              <button onClick={() => this.deleteProduct(product["@id"])}>
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
